import React from 'react';
import { Box, Typography } from '@mui/material';

const KIND_ICONS = {
  door: '🚪',
  kitchen: '🍳',
  bar: '🍷',
  pos: '💳',
  restroom: '🚻',
  wall: '▬',
  plant: '🌿',
  stairs: '📶',
};

const FloorObjectGlyph = ({ object, selected, showLabel = true }) => {
  const color = object?.color || '#64748B';
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: object?.kind === 'plant' ? '50%' : 1.5,
        bgcolor: `${color}1F`,
        border: selected ? '2px solid #2D7FF9' : `1.5px solid ${color}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        overflow: 'hidden',
        userSelect: 'none',
        boxShadow: selected ? '0 0 0 3px rgba(45,127,249,0.18)' : 'none',
        transition: 'box-shadow 0.15s ease',
      }}
    >
      <Typography sx={{ fontSize: 16, lineHeight: 1 }}>
        {KIND_ICONS[object?.kind] || '■'}
      </Typography>
      {showLabel ? (
        <Typography
          sx={{
            fontSize: 10,
            fontWeight: 700,
            color: '#0F172A',
            mt: 0.25,
            px: 0.5,
            textAlign: 'center',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
          }}
        >
          {object?.label || object?.kind}
        </Typography>
      ) : null}
    </Box>
  );
};

export default FloorObjectGlyph;
